
import { defineComponent } from 'vue'

export default defineComponent({
  emits: ["changed", "update:modelValue"],
  props: {
    options: {
      type: Array,
    },
    modelValue: {} as any,
    modelModifiers: {
      default: () => ({}),
    },
  },
  data() {
    return {
      id: "",
      itemSelected: {} as any,
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(val) {
        if (!!val) {
          if (typeof val == "object") {
            const item = this.options?.find((x:any) => x.id == val.id);
            this.itemSelected = item;
          } else {
            const item = this.options?.find((x:any) => x.id == val);
            this.itemSelected = item;
          }
        }
      },
    },
    options: {
      immediate: true,
      handler(val) {
        if (!!val && val.IsNotNullOrEmpty()) {
          const id = this.modelValue?.id;
          if (!id) {
            this.$emit("update:modelValue", val[0]);
          }
        }
      },
    },
    itemSelected(val) {
      this.$emit("changed", val);
    },
  },
  methods: {
    onSelectedItem(item:Event) {
      this.$emit("update:modelValue", item);
    },
  },
  mounted() {
    this.id = this.uid;
  },
});
